import { retrieveJsonRequest } from "./utils.js";

export async function fetchCustomizations() {
    return retrieveJsonRequest(`/res/find_and_replace/customizations`, "GET", "omit");
}
